var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 bigger",class:{ 'personal-container': _vm.$vuetify.breakpoint.mdAndUp },attrs:{"fluid":""}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }